import React, { useState, useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
    Typography,
} from '@mui/material'
import AppFAQItem from '../../components/ui/AppFAQ'
import { FAQUrl } from '../../common/url'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { App_Language_key } from '../../common/config'

export const SMAppFAQ: React.FC = () => {
    const { t } = useTranslation()

    const [data, setData] = useState(null)

    const typeList = ['General', 'Motorcycle', 'Personal Loan', 'SHENMA Mobile']

    const [tabIndex, updateTabIndex] = useState(0)

    const btnData = [
        {
            'title': t('t382'),
        },
        {
            'title': t('t383'),
        },
        {
            'title': t('t384'),
        },
        {
            'title': t('t385'),
        }
    ]

    useEffect(() => {
        (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabIndex])

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'

    const fetchList = async () => {
        try {
            var url = FAQUrl + '?publicationState=live&sort=sequence:ASC&filters[language][$eq]='+ language + '&filters[category][$eq]=' + typeList[tabIndex]
            const response = await axios.get(url)
            if (response.status === 200) {
                setData(response.data['data'])
            }
        } catch (error) {
            console.error(error)
        }
    }


    const changeTabIndex = (index: number) => {
        updateTabIndex(index)
    }

    // ======================= RENDER FUNCTIONS
    const renderFaqAccordion = (index: number) => (
        <AppFAQItem data={data}></AppFAQItem>
    )

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '60px',
            paddingBottom: '40px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Typography fontSize={24} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                {t('t164')}
            </Typography>

            <Grid container rowSpacing={2} columnSpacing={2} marginTop={'24px'}>
                {btnData.map((item, index) => (
                    <Grid item key={index} xs={6}>
                        <Box sx={{
                            backgroundColor: index === tabIndex ? '#FFC107' : '#FFFFFF',
                            borderRadius: '30px',
                            border: index === tabIndex ? 'none' : '1px solid #141F39'
                        }}>
                            <Button
                                fullWidth
                                onClick={() => changeTabIndex(index)}
                                sx={{
                                    height: '60px',
                                    color: '#141F39',
                                    textTransform: 'none'
                                }}

                            >
                                {btnData[index]['title']}
                            </Button>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            <Box sx={{
                paddingTop: '40px',
            }}>
                {renderFaqAccordion()}
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppFAQ
